module.exports = __webpack_public_path__ + "img/empty-member-enterprise.d480fc50.svg";